import React from 'react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { Species } from '../../utils/mockData';
interface SpeciesCardProps {
  species: Species;
}
export function SpeciesCard({
  species
}: SpeciesCardProps) {
  return <Card variant="elevated" className="flex flex-row overflow-hidden h-32" data-id="element-44">
      <div className="w-1/3" data-id="element-45">
        <img src={species.image} alt={species.name} className="w-full h-full object-cover" data-id="element-46" />
      </div>
      <div className="w-2/3 p-4 flex flex-col justify-center" data-id="element-47">
        <h3 className="font-bold text-text text-lg mb-1" data-id="element-48">{species.name}</h3>
        <div className="mb-2" data-id="element-49">
          <Badge variant="accent" data-id="element-50">{species.season}</Badge>
        </div>
        <p className="text-xs text-text-muted line-clamp-2" data-id="element-51">{species.tips}</p>
      </div>
    </Card>;
}